import styled, { css } from 'styled-components';

interface FilterRadioButtonsContainerInterface {
  flexDirection?: string;
  notOverflow?: boolean;
  marginBottom?: string;
}

export const FilterRadioButtonsContainer = styled.div<FilterRadioButtonsContainerInterface>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  max-width: 100%;
  overflow: auto;

  ${({ notOverflow }) => notOverflow && css`
    max-width: unset;
    overflow: unset;
  `}

  ${({ marginBottom }) => marginBottom && css`
    margin-bottom: ${marginBottom};
  `}

  @media(max-width: 500px) {
    display: flex;
    flex-direction: ${({ flexDirection }) => flexDirection || 'row'};
    gap: 6px;
  }
`;
